import React from 'react';

import { Table, Column, Loader } from '@smartplatform/ui';
import { useGetRecords } from 'root/admin/components/hooks';
import { CreateNew } from 'root/admin/components';
import store from 'root/admin/store';

const TagsList = ({ rootPath, model, tabName, modelName }) => {
	const records = useGetRecords({ model, tabName });
	if (!records) {
		return <Loader />;
	}

	return (
		<div>
			<CreateNew link={`${rootPath}/${tabName}/new`} name={`Новый ${modelName}`} />

			<Table records={records} rootPath={rootPath}>
				<Column property="name" label="Название категории" />
			</Table>
		</div>
	);
};

export default TagsList;
